<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue'
import { useAuthStore } from '@/stores/auth'
import { useAppConfigStore } from '@/stores/appConfig'
import { onMounted } from 'vue'

const authStore = useAuthStore()
const appConfigStore = useAppConfigStore()

onMounted(async () => {
  await appConfigStore.fetchConfig()

  if (authStore.token) {
    try {
      await authStore.fetchUser()
    } catch (error) {
      authStore.logout()
    }
  }
})
</script>

<style>
ion-app {
  --ion-safe-area-top: env(safe-area-inset-top);
  --ion-safe-area-bottom: env(safe-area-inset-bottom);
  --ion-safe-area-left: env(safe-area-inset-left);
  --ion-safe-area-right: env(safe-area-inset-right);
}
</style>
